import axios from "utils/axios";
import { stringify } from "query-string";

export const getKpiReviews = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/kpi/reviews/pagination?${query}`);
};

export const getKpiReviewsSummary = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/kpi/reviews/summary/pagination?${query}`);
};

export const getKpiReview = (data) => {
  return axios.get(`/hr/kpi/reviews/${data?.id}`);
};

export const getKpiReviewSummary = (data) => {
  return axios.get(`/hr/kpi/reviews/summary/${data?.id}`);
};

export const getKpiReviewSummaryEmployee = (data) => {
  return axios.get(
    `/hr/kpi/reviews/summary/${data?.id}/employee/${data?.hr_employee_id}`
  );
};

export const addKpiReview = (data) => {
  return axios.post(`/hr/kpi/reviews`, data);
};

export const addKpiReviewSummary = (data) => {
  return axios.post(`/hr/kpi/reviews/summary`, data);
};

export const addPostKpiReviewSummary = (data) => {
  return axios.post(`/hr/kpi/reviews/summary/${data?.id}/post`, data);
};

export const sendAnnouncementKpiReviewSummary = (id) => {
  return axios.post(`/hr/kpi/reviews/summary/${id}/post`);
};

export const sendScoreKpiReviewSummary = (id) => {
  return axios.post(`/hr/kpi/reviews/summary/${id}/send-score`);
};

export const editKpiReview = (data) => {
  return axios.put(`/hr/kpi/reviews/${data?.id}`, data);
};

export const editNameKpiReviewSummary = (data) => {
  return axios.patch(`/hr/kpi/reviews/summary/${data?.id}/rename`, data);
};

export const editEvaluationDateKpiReviewSummary = (data) => {
  return axios.patch(
    `/hr/kpi/reviews/summary/${data?.id}/update-evaluation-date`,
    data
  );
};

export const deleteKpiReview = (id) => {
  return axios.delete(`/hr/kpi/reviews/${id}`);
};

export const deleteAttachmentKpiReview = (data) => {
  return axios.delete(
    `/hr/kpi/reviews/indicators/${data?.resultIndicatorId}/attachment/delete/${data?.id}`
  );
};
